import type { DiffLine } from "@/utils/textDiff";

const LINE_CLASS: Record<string, string> = {
  added: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
  removed: "bg-rose-500/10 text-rose-700 dark:text-rose-300 line-through decoration-rose-400/60",
  same: "text-muted-foreground",
};
const PREFIX: Record<string, string> = { added: "+ ", removed: "- ", same: "  " };

export function TextDiffView({ title, lines }: { title: string; lines: DiffLine[] }) {
  return (
    <div className="grid gap-1.5">
      <strong className="text-sm">{title}</strong>
      <pre className="m-0 max-h-96 overflow-auto rounded-lg border border-border bg-surface-input p-2 font-mono text-xs">
        {lines.map((line, index) =>
          line.kind === "skip" ? (
            <div key={index} className="py-0.5 text-center text-muted-foreground">
              … {line.count} unchanged line{line.count === 1 ? "" : "s"} …
            </div>
          ) : (
            <div key={index} className={`whitespace-pre-wrap wrap-anywhere ${LINE_CLASS[line.kind]}`}>
              {PREFIX[line.kind]}
              {line.text}
            </div>
          ),
        )}
      </pre>
    </div>
  );
}
